export function isRumDebugEnabled(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }

    return new URLSearchParams(window.location.search).get('rumdebug') === '1';
}
